import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { GetPostByCategorySlug } from '../services/apiservice';
import { useParams } from 'react-router-dom';
import BlogItem from '../Components/BlogItem';
import Loader from '../Components/Loader';
import BlogSidebar from '../Components/BlogSidebar';

const CategoryBlog = () => {
  const [blogPost, setBlogPost] = useState([]);
  const [loading, setLoading] = useState(true);

  const { categorypk } = useParams(); // 👈 get the slug from URL
  
  const fillBlogPost = async () => {
    try {
      const postList = await GetPostByCategorySlug(categorypk);
      const jsonPostList = JSON.parse(postList);
      setBlogPost(jsonPostList);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching the data:', error);
    }
  }

  useEffect(() => {
    fillBlogPost();
  }, []);

  return (
    <div>
      <Header />
      <div class="blog-area blog-section ptb-20">
        <div class="container-block-fluid">
          <div class="row">
            <div class="full-col col-lg-8 col-12">
              <div class="row justify-content-center">
                {
                  loading ? <Loader /> :
                    blogPost?.length == 0 ? "No Blog Post Published yet." :
                      blogPost?.map((item) => (
                        <BlogItem blogitem={item} />
                      ))
                }
              </div>
            </div>
            <div class="full-col col-lg-4 col-12">
              <BlogSidebar />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CategoryBlog;